import React from "react";
import { Image, Stack } from "react-bootstrap";
import ImageWarningOrangeCircle from "../../images/warning-alert-circle-orange.svg";
import "./WarningBadge.scss";

interface WarningBadgeProps {
  text: string;
  textClassName?: string;
  containerClassName?: string;
  iconSize?: number;
}

export default function WarningBadge({
  text,
  textClassName = "",
  containerClassName = "",
  iconSize = 11,
}: WarningBadgeProps) {
  return (
    <Stack
      direction="horizontal"
      className={`WarningBadge ${containerClassName}`}
    >
      <Image
        src={ImageWarningOrangeCircle}
        width={iconSize}
        height={iconSize}
      />
      <p className={`WarningText ${textClassName}`}>{text}</p>
    </Stack>
  );
}
